export default "__VITE_ASSET__042232b0__"